'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function chatLinesController($window) {
    //const
    var vm = this;

    //vars
    vm.observerConfig = { attributes: false, childList: true };
    vm.element = null;
    vm.observer = null;
    vm.needleLines = ['bijlage toevoegen', 'toevoegen beginnen', 'controleer tot slot nog'];

    var observerCallback = function observerCallback() {
        vm.checkChatLine();
    };

    vm.setElement = function (element) {
        vm.element = element;
    };

    vm.checkLineContainsNeedle = function (line) {
        var foundNeedles = vm.needleLines.filter(function (needleLine) {
            return line.innerText.toLowerCase().indexOf(needleLine) > -1;
        });
        return foundNeedles.length > 0;
    };

    vm.init = function () {
        if ($window.MutationObserver) {
            vm.observer = new MutationObserver(observerCallback);
            vm.observer.observe(vm.element, vm.observerConfig);
        }
    };
}

chatLinesController.$inject = ['$window'];

exports.default = chatLinesController;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/chat/chat-lines.controller.js
// module id = 870
// module chunks = 0